import React, { useEffect, useState, useContext } from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { Box, Button, Typography, ButtonGroup } from '@mui/material';
import { fetchToken, fetchRole } from '../auth/Token';
import { api } from '../api';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import AuthContext from "../auth/AuthProvider";
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useFormik, validateYupSchema } from 'formik';
import * as Yup from 'yup';
import { DataGrid, GridToolbar, GridRowParams, GridActionsCellItem} from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';
import TransactionDetails from './TransactionDetails';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { toast } from 'sonner';


const FormatedDate = ({value}) => {
    const timestamp = value;
    const date = new Date(timestamp);
  
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours() % 12 || 12).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const amOrPm = date.getHours() >= 12 ? 'PM' : 'AM';
  
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes} ${amOrPm}`;
    return <span>{formattedDate}</span>;
  }

export default function LoansDetails(props) {
    const [info, setInfo] = useState([])
    const [loanOpen, setLoanOpen] = useState(false);
    const [payOpen, setPayOpen] = useState(false);
    const [alert, setAlert] = useState()
    const [transactionDetails, setTransactionDetails] = useState([])
    const {  permissions } = useContext(AuthContext);
    const [start_date, setStart_date] = useState('')
    const [end_date, setEnd_date] = useState('')
    // const [soc, setSoc] = useState();

    
    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        height: '125vh', 
        color: theme.palette.text.secondary,
      }));

    const fetchloansDetails = () => {
        try{
            api.get(`/account/loan/${props.ID}`,{
                headers: {
                    Authorization: 'Bearer ' + fetchToken()
                }
            }).then(function (response){
                setInfo(response.data)
            })
                
            
        } catch (error) {
            console.log(error)
        }
    }
            
      useEffect(() => {
       fetchloansDetails();
      },[])

      const savings_acc_id = props.ID
      const type = "loans"

      const [total_wit, setTotal_wit] = useState();
      const [total_dep, setTotal_dep] = useState();

        const fetchTransactions = () => {
            const tj = new FormData();
            tj.append('member_loans_acc_id', props.ID)
            tj.append('start_date', start_date)
            tj.append('end_date', end_date)

            api.post('/transactions/transaction/loan/member_loans_acc_id', tj, {
                headers: {
                    Authorization: 'Bearer '+ fetchToken()
                },
            }).then(function (response) {
                setTransactionDetails(response.data?.data)
                setTotal_wit(response.data?.total_wit);
                setTotal_dep(response.data?.total_dep);
            }).catch(function (error) {
                console.log(error)
            })
        }
        // console.log(total_wit);

        const fetchTransactions_unfil = () =>{
            setStart_date('')
            setEnd_date('')
            fetchTransactions()
          } 

      useEffect(() => {
        fetchTransactions();
      },[])

    //   console.log(transactionDetails);

      const columns = [
        {
            field: "transaction_date",
            headerName: 'DateTime',
            flex: 1,
            cellClassName: "name-column--cell",
            renderCell:(params) => <FormatedDate value={params.row.transaction_date}/>
        },
        {
            field: "narration",
            headerName: "Narration",
            flex:1,
            width: 70,
        },
        {
            field: "debit",
            headerName: "Debit(GHS)",
            flex:1,
            width: 70,
            renderCell:(params) => (params.row.transactiontype_name === "Withdraw")? params.row.amount : 0
        },
        {
            field: "credit",
            headerName: "Credit(GHS)",
            flex:1,
            width: 70,
            renderCell:(params) => (params.row.transactiontype_name === "Deposit")? params.row.amount : 0
        },
        {
            field: "balance",
            headerName: "Account Balance",
            flex:1,
            width: 70,
        },
        {
            field: "transaction_id",
            headerName: "Id",
            flex:1,
            width: 70,
        },
        {
            field: "transactiontype_name",
            headerName: "Type",
            flex:1,
            width: 70,
            // renderCell: (params) => {
            //     if (params.row.transactiontype_name === "Deposit"){
            //         return "Pay Off"
            //     }else{
            //         return "Request"
            //     }
            // }
        },
        {
            field: "amount",
            headerName: "Amount(GH₵)",
            flex:1,
            width: 70,
        },
        {
            field: "username",
            headerName: "Prepared by",
            flex:1,
            width: 70,
        },
        {
            field: "status",
            headerName: "Status",
            flex:1,
            width: 70,
            renderCell:(params) => {
                if(params.row.status === "Requested"){
                    // <Button variant='contained' color='secondary'>Pending Request</Button>
                    return "Pending Request"
                }else if(params.row.status === "Disbursed"){
                    // <Button variant='contained' color='success'>Disbursed</Button>
                    return "Disbursed"
                }
            }
        }, 
        {
            field: "update",
            type:'action',
            headerName: "Action",
            // flex: 1,
            width:20,
            renderCell: (params) => <TransactionDetails {...{params, type, info, savings_acc_id, fetchTransactions, fetchloansDetails }} />
        },
        {
            field: 'delete',
            type: 'actions',
            width:20,
            getActions: (params: GridRowParams) => [
            <GridActionsCellItem
            icon={<DeleteIcon />}
            onClick={() => handleClickOpen(params.row.transaction_id)} 
            label="Open"
            />,]
        },
    ]
      const [messageid, setMessageid] = useState();
      const [openn, setOpenn] = useState(false);

      const handleClickOpen = (id) => {
            setOpenn(true);
            setMessageid(id)
      }

      const handleDelete = () => {
        const id = messageid
        try {
            api.delete(`/transactions/transaction/loans/${id}`,{
             headers :{
               Authorization: 'Bearer '+ fetchToken()
             }
           }).then(function (response){
                toast.success(response.data)
                setOpenn(false)
                fetchloansDetails();
                fetchTransactions();
                if(response.data === "Account Deleted"){
                    props.fetchAccounts();
                     handleClose(); 
                 }
           }).catch(function (error){
                console.log(error)
           })
         } 
         catch(error){
         console.log('This is that error', error )
       };
    };

      const handleClose = () => {
        props.setOpen_acc();
      };

      const handleRequest = () =>{
        setLoanOpen(true)
      };

      const handlePay = () => {
        setPayOpen(true)
      };

      const closePay = () => {
        setPayOpen(false)
      };

      const closeRequest = () => {
        setLoanOpen(false)
      };

    //   Loan Request
    const formik = useFormik({
        initialValues: {
            transactiontype_id: 2,
            Amount: null,
            narration: '',
            loans_acc_id: props.ID,
            type: 'cash',
            percent: null
        },
        validationSchema: Yup.object({
            Amount: Yup.number()
                .required('Specify Amount to Request')
                .min(info[0]?.Min_amt)
                .max(info[0]?.Max_amt),
            narration: Yup.string()
        }),
        onSubmit: (values) => {
            api.post('/transactions/transaction/loans', values , {
                headers: {
                    Authorization:'Bearer ' + fetchToken(),
                },
            }).then(function (response) {
                toast.success(response.data)
                formik.handleReset()
                setAlert()
                closeRequest()
                fetchloansDetails();
                fetchTransactions();
                props.fetchAccounts();
            }).catch(function (error){
                // setAlert(<Alert severity="error">{error.response.data.detail}</Alert>)
                console.log(error)
            })
        }
    })

    // Loan Pay Off
    const formikk = useFormik({
        initialValues: {
            transactiontype_id: 1,
            Amount: null,
            narration: '',
            loans_acc_id: props.ID,
            type: 'cash',
            percent: null
        },
        validationSchema: Yup.object({
            Amount: Yup.number()
                .required('Specify Amount to Pay'),
            narration: Yup.string()
        }),
        onSubmit: (values) => {
            api.post('/transactions/transaction/loans', values , {
                headers: {
                    Authorization:'Bearer ' + fetchToken(),
                },
            }).then(function (response) {
                toast.success(response.data)
                formikk.handleReset()
                setAlert()
                closePay()
                fetchloansDetails();
                props.fetchAccounts();
                fetchTransactions();
            }).catch(function (error){
                // setAlert(<Alert severity="error">{error.response.data.detail}</Alert>)
                console.log(error)
            })
        }
    })

      const [open, setOpen] = useState(false);

    const handleDeleteAcc = () =>{
        api.delete(`account/delete_acc/loan/${props.ID}`, {
            headers: {
                Authorization: 'Bearer '+fetchToken()
            },
        }).then(function (response){
            setOpen(false);
            toast.success(response.data);
            if(response.data === "Account Deleted"){
               props.fetchAccounts();
                handleClose(); 
            }
        }).catch(function (error){
            console.log(error);
        })
    }

    const CustomFooterRow = () => {
        return (
          <div>
            <div style={{ display: 'flex', padding: '4px' }}>
              <Typography variant="h5" sx={{ color:'red', mr:4 }}>Total:</Typography>
              <Typography variant="h5" sx={{ color:'darkblue', mr:4 }}>Debit: {total_wit} </Typography>
              <Typography variant="h5" sx={{ color:'darkblue', mr:4 }}>Credit: {total_dep} </Typography>
             </div>
          </div>
        );
    };
    
    
if(transactionDetails){
  return (
    <div>
        <Item>
            {alert}
            <Box
                sx={{
                     display:'flex',
                     justifyContent:'space-between'
                    }}
            ><Button onClick={handleClose} variant='contained' color='warning'>Close</Button>
                <Typography>Current Balance: {info[0]?.current_balance}</Typography>
                <Typography variant='h4' sx={{ fontWeight: '700',color:'darkblue' }}>{props.name}</Typography>
                <Typography>Open date: {info[0]?.open_date}</Typography>
            </Box>

            <Box
                sx={{ 
                    display:'flex-end'
                 }}
            >
                {
                    permissions && permissions.request_loan_transactions === true ?
                    <ButtonGroup variant="contained" aria-label="outlined primary button group">
                        <Button onClick={handleRequest}>Request for loan</Button>
                        <Button onClick={handlePay} disabled={info[0]?.current_balance >= 0 ? true :false}>Pay off loan</Button>
                    </ButtonGroup>
                    : null
                }
                

            </Box>
            <Box
                m="40px 0 0 0"
                height="85vh"
                paddingBottom="55px"
            >
                {
                    permissions && permissions.view_loan_transactions === true ?
                    <>
                    <Typography variant='h3' sx={{ marginBottom:'10px' }}>Current Loans</Typography>
                    <>
                <Typography>Filter Date</Typography>
                <div style={{ display:'flex' }}>
                <TextField
                    type='date'
                    size="small"
                    required
                    variant="outlined"
                    helperText="From"
                    name="start_date"
                    onChange={(e) => setStart_date(e.target.value)}
                    value={start_date}
                    sx={{ mr:1 }}
                />

                <TextField
                    type='date'
                    size="small"
                    required 
                    variant="outlined"
                    helperText="To"
                    name="end_date"
                    onChange={(e) => setEnd_date(e.target.value)}
                    value={end_date}
                    sx={{ mr:1 }}
                />

                <IconButton sx={{ mb:2 }} onClick={fetchTransactions}><FilterAltOutlinedIcon /></IconButton>
                <IconButton sx={{ mb:2 }} onClick={fetchTransactions_unfil}><CancelIcon /></IconButton>
                </div>
                </>
                    <DataGrid
                        rows={transactionDetails}
                        columns={columns}
                        checkboxSelection
                        getRowId={(row) => row.transaction_id}
                        slots={{ toolbar: GridToolbar, footer: CustomFooterRow }}
                        initialState={{
                            columns: {
                            columnVisibilityModel: {
                                transaction_id: false,
                                amount:false,
                                username:false,
                                transactiontype_name:false
                            },
                            },
                        }}
                    />
                    </>
                    :null
                }

                        <Button
                            sx={{ m:2 }}
                            onClick={()=>setOpen(true)}
                            variant='contained'
                            color='warning'
                        >
                            Delete Account
                        </Button>
                
            </Box>

            <Dialog
                    open={open}
                    onClose={() =>setOpen(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                    {"Delete Account"}
                    </DialogTitle>
                    <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        This action cannot be undone. NB: this will also delete all
                        transactions in this account. As well as Loan Advise.
                        Do you wish to continue?
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleDeleteAcc} autoFocus>
                        Continue
                    </Button>
                    </DialogActions>
                </Dialog>
        </Item>
        
        {/* Request */}
        <Dialog open={loanOpen} onClose={closeRequest}>
            <form onSubmit={formik.handleSubmit}>
            <DialogTitle>Transaction</DialogTitle>
            <DialogContent>
            <DialogContentText>
                Loan Request
            </DialogContentText>
            Min Amount:
            <Typography sx={{ fontWeight: '700' }}>GH₵{info[0]?.Min_amt}.00</Typography>
            Max Amount:
            <Typography sx={{ fontWeight: '700' }}>GH₵{info[0]?.Max_amt}.00</Typography>
            <TextField
                margin="dense"
                id="Amount"
                name="Amount"
                label="Amount"
                onChange={formik.handleChange}
                value={formik.values.Amount}
                onBlur={formik.handleBlur}
                error={formik.touched.Amount && Boolean(formik.errors.Amount)}
                helperText={formik.touched.Amount && formik.errors.Amount}
                type="number"
                fullWidth
                variant="outlined"
            />

            <TextField
                margin="dense"
                id="narration"
                name="narration"
                label="Narration (optional)"
                onChange={formik.handleChange}
                type="text"
                value={formik.values.narration}
                onBlur={formik.handleBlur}
                error={formik.touched.narration && Boolean(formik.errors.narration)}
                helperText={formik.touched.narration && formik.errors.narration}
                fullWidth
                variant="outlined"
            />
            
            </DialogContent>
            <DialogActions>
            <Button onClick={closeRequest}>Cancel</Button>
            <Button type='submit'>Request</Button>
            </DialogActions>
            </form>
        </Dialog>

        {/* Pay */}
        <Dialog open={payOpen} onClose={closePay}>
            <form onSubmit={formikk.handleSubmit}>
            <DialogTitle>Transaction</DialogTitle>
            <DialogContent>
            <DialogContentText>
                Loan Pay Off
            </DialogContentText>
            <TextField
                margin="dense"
                id="Amount"
                name="Amount"
                label="Amount"
                onChange={formikk.handleChange}
                value={formikk.values.Amount}
                onBlur={formikk.handleBlur}
                error={formikk.touched.Amount && Boolean(formikk.errors.Amount)}
                helperText={formikk.touched.Amount && formikk.errors.Amount}
                type="number"
                fullWidth
                variant="outlined"
            />

            <TextField
                margin="dense"
                id="narration"
                name="narration"
                label="Narration (optional)"
                onChange={formikk.handleChange}
                type="text"
                value={formikk.values.narration}
                onBlur={formikk.handleBlur}
                error={formikk.touched.narration && Boolean(formikk.errors.narration)}
                helperText={formikk.touched.narration && formikk.errors.narration}
                fullWidth
                variant="outlined"
            />
            
            </DialogContent>
            <DialogActions>
            <Button onClick={closePay}>Cancel</Button>
            <Button type='submit'>Pay</Button>
            </DialogActions>
            </form>
        </Dialog>
        <Dialog
            open={openn}
            onClose={() =>setOpenn(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
            {"Delete Transaction"}
            </DialogTitle>
            <DialogContent>
            <DialogContentText id="alert-dialog-description">
                This action cannot be undone. NB: this will also affect the
                current balance of the account.
                Do you wish to continue?
            </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={() =>setOpenn(false)}>Cancel</Button>
            <Button onClick={handleDelete} autoFocus>
                Continue
            </Button>
            </DialogActions>
        </Dialog>

    </div>
  )
}else{
    return(
        <Item>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
          onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        </Item>
    )
}
}
